import { render } from "./BaseCard.vue?vue&type=template&id=697a8b6a&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=697a8b6a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-697a8b6a"]])

export default __exports__